import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const Wrapper = styled.div<{ $fullScreen?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${myPalette.aliceBlue.main};
  padding: 10px;
  min-height: ${({ $fullScreen }) => ($fullScreen ? '100vh' : 'none')};
`

export const Title = styled.div`
  font-size: 20px;
  font-weight: 500;
  text-align: center;
`
